import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  Optional,
  signal,
} from "@angular/core";
import { ITag } from "../../../../core-ui";
import { CardComponent } from "../card/card.component";

@Component({
  selector: "av-tag-manager",
  templateUrl: "./tag-manager.component.html",
  styleUrls: ["./tag-manager.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagManagerComponent {
  @Input() items: ITag[];
  @Input() placeholder: string = "";

  @Output() changed = new EventEmitter<ITag[]>();

  newItemValue: string;
  color = signal<string>("basic");

  constructor(@Optional() private card: CardComponent) {
    if (!!card) {
      this.color.set("accent");
    }
  }

  itemRemoved(tag: ITag) {
    // this.items.update((types) =>
    //   types.filter((t) => t.value !== tag.value)
    // );
    this.items = this.items.filter((t) => t.value !== tag.value);
    this.changed.emit(this.items);
  }

  addItem(value: string) {
    if (!value) {
      return;
    }
    if (this.items.some((t) => t.value === value)) {
      return;
    }
    this.items = [...this.items, { value: value.trim(), label: value.trim() }];
    // this.cobrowseFilters.update((items) => [
    //   ...items,
    //   { value: value.trim(), label: value.trim() },
    // ]);
    this.newItemValue = undefined;

    this.changed.emit(this.items);
  }
}
